<template>
  <textarea
    :class="['v2-textarea', { 'v2-textarea--error': error }]"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    :required="required"
    :rows="rows"
    :maxlength="maxlength"
    :aria-invalid="error ? 'true' : undefined"
    :aria-describedby="helper ? `${_uid}-helper` : undefined"
    @input="onInput"
  />
</template>

<script>
let uidCounter = 0;
export default {
  name: "BaseTextarea",
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    rows: { type: Number, default: 4 },
    maxlength: { type: Number, default: undefined },
  },
  data() {
    uidCounter += 1;
    return { _uid: uidCounter };
  },
  methods: {
    onInput(event) {
      this.$emit("input", event.target.value);
      this.$emit("update", event.target.value);
    },
  },
};
</script>

<style scoped>
.v2-textarea {
  display: block;
  width: 100%;
  padding: var(--space-3);
  font-family: var(--font-body);
  font-size: var(--fs-body-sm);
  color: var(--color-text);
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  resize: vertical;
  min-height: 80px;
  line-height: var(--lh-normal);
}

.v2-textarea:focus {
  outline: none;
  border-color: var(--color-amber);
  box-shadow: 0 0 0 1px var(--color-amber);
}

.v2-textarea:disabled {
  background-color: var(--color-neutral-50);
  color: var(--color-text-muted);
  cursor: not-allowed;
}

.v2-textarea--error {
  border-color: var(--color-error);
}
</style>
